<template>
    <div class="wrapper padding-sm bg-white">
        <div class=" flex justify-between align-center margin-bottom-sm">
            <div class="page-title ">自定义会员信息</div>
            <el-button class="add-btn" @click="infoDialog = true"  v-if="user.isBranch">添加信息</el-button>
        </div>
        <div class="classifys flex align-center">
            <router-link to="/branch/setup/information" class="classify ">单位会员</router-link>
            <router-link to="/branch/setup/sinformation" class="classify active">个人会员</router-link>
        </div>
        <el-form ref="ruleForm" :model="infoForm" class="ruleForm" label-width="auto">
            <vuedraggable v-model="infoForm.list"
                          :move="onMove"
                          class="swrapper"
                          v-bind="dragOptions"
                          @end="isDragging=false"
                          @start="isDragging=true"
                          :disabled="!user.isBranch"
                          @update="draggableEnd">
                <transition-group>
                    <div v-for="(item,index) in infoForm.list" :key="item.title + index"
                         class="flex align-center justify-between">
                        <div class="zt-img">
                            <el-tooltip class="item" content="可拖拽排序" effect="dark" placement="top"  v-if="user.isBranch">
                                <img alt="" src="../../../../assets/img/tuozhuai.png">
                            </el-tooltip>

                        </div>
                        <div class="flex-sub margin-lr">
                            <el-form-item v-if="item.type === 1" :label="item.title" :prop="'list.' + index + '.answer'"
                                          :rules="item.rules">
                                <el-input v-model="item.answer" :placeholder="'请输入' + item.title"></el-input>
                            </el-form-item>
                            <el-form-item v-if="item.type === 2" :label="item.title" :prop="'list.' + index + '.answer'"
                                          :rules="item.rules">
                                <el-input v-model="item.answer" :placeholder="'请输入' + item.title"
                                          type="textarea"></el-input>
                            </el-form-item>
                            <el-form-item v-if="item.type === 3" :label="item.title" :prop="'list.' + index + '.answer'"
                                          :rules="item.rules">
                                <el-select v-model="item.answer" :placeholder="'请选择' + item.title" class="w-all"
                                           clearable>
                                    <el-option v-for="option in item.options" :key="option.value"
                                               :label="option.label"
                                               :value="option.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="item.type === 4" :label="item.title" :prop="'list.' + index + '.answer'"
                                          :rules="item.rules">
                                <el-select v-model="item.answer" :placeholder="'请选择' + item.title" class="w-all"
                                           clearable multiple>
                                    <el-option v-for="option in item.options" :key="option.value"
                                               :label="option.label"
                                               :value="option.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="item.type === 5" :label="item.title" :prop="'list.' + index + '.answer'"
                                          :rules="item.rules">
                                <el-cascader
                                    v-model="item.answer"
                                    :options="options"
                                    expand-trigger="hover"
                                    filterable
                                    placeholder="请选择机构所在地"
                                    style="width: 100%;"
                                >
                                </el-cascader>
                            </el-form-item>
                            <el-form-item v-if="item.type === 6" :label="item.title" :rules="item.rules">
                                <infoUpFile :limit="item.limit" :type="item.type"/>
                            </el-form-item>
                            <el-form-item v-if="item.type === 7" :label="item.title" :rules="item.rules">
                                <infoUpFile :limit="item.limit" :type="item.type"/>
                            </el-form-item>
                            <el-form-item v-if="item.type === 8" :label="item.title"  :prop="'list.' + index + '.answer'" :rules="item.rules">
                                <el-date-picker
                                    v-model="item.answer"
                                    placeholder="请选择日期"
                                    style="width: 100%"
                                    value-format="yyyy-MM-dd"
                                    type="date">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="set-box"  v-if="user.isBranch">
                            <el-button v-if="item.isSet" class="blue-btn" round @click="editItem(index)">编辑</el-button>
                            <el-button v-if="item.isSet" class="line-btn" round @click="deleteItem(index)">删除</el-button>
                        </div>
                    </div>
                </transition-group>
            </vuedraggable>
            <el-form-item label-width="0">
                <div class="flex justify-center">
                    <el-button class="blue-btn big-btn" round @click="saveForm"  v-if="user.isBranch">保存</el-button>
                </div>
            </el-form-item>
        </el-form>
        <info-dialog
            :infoDialog="infoDialog"
            :setIndex="setIndex"
            :setItem="setItem"
            @cancelDialog="cancelDialog"
        />
    </div>
</template>

<script>
import vuedraggable from 'vuedraggable';
import {regionData} from "element-china-area-data";
import infoDialog from "@/components/InfoDialog";
import infoUpFile from "@/components/InfoUpFile";
import {getPersonalInformation, getRankList, savePersonalInformation} from "@/api/branch";
import rules from "@/utils/rules";
import {patternChange} from "../../../../utils/utils";

export default {
    name: "information",
    data() {
        return {
            infoForm: {
                list: [
                    {
                        type: 1,
                        title: '会员姓名',
                        field: 'name',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}]
                    },{
                        type: 3,
                        title: '会员等级',
                        field: 'rankId',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请选择', trigger: 'change'}]
                    }, {
                        type: 1,
                        title: '会员电话',
                        field: 'phone',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: rules.tel
                    },
                    {
                        type: 1,
                        title: '所属机构',
                        field: 'company',
                        answer: '',
                        options: [],
                        isMust: true,
                        isSet: false,
                        rules: [{required: true, message: '请输入', trigger: 'blur'}]
                    }
                ],
            },
            options: regionData,

            infoDialog: false,
            setIndex: -1,
            setItem: {},

            isDragging: false,
            delayedDragging: false,
            isDraggable: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                ghostClass: "ghost"
            };
        }
    },
    created() {
        this.$emit('setIndex', [2, 3], '信息设置')
        this.getInformation()
        // this.getUserMoreJson()
    },
    components: {
        vuedraggable,
        infoDialog,
        infoUpFile
    },
    methods: {

        //  保存表单
        async saveForm() {
            this.infoForm.list.map(item => {
                if (item.type === 4 || item.type === 5 || item.type === 6 || item.type === 7) {
                    item.answer = []
                } else {
                    item.answer = ''
                }
            })
            let _state = await savePersonalInformation(JSON.stringify(this.infoForm.list))
            this.$message.success(_state.msg)
        },
        //  删除表单项
        deleteItem(index) {
            this.$confirm("确定要删除吗？", "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.infoForm.list.splice(index, 1)
            });
        },
        //  编辑表单项
        editItem(index) {
            this.setItem = this.infoForm.list[index];
            this.setIndex = index;
            this.infoDialog = true;
        },
        //  关闭表单弹窗
        cancelDialog(val) {
            if (val[0]) {
                if (this.setIndex === -1) {
                    this.infoForm.list.push(val[1])
                } else {
                    this.$set(this.infoForm.list, this.setIndex, val[1])
                }
            }
            this.setIndex = -1;
            this.setItem = {};
            this.infoDialog = false;
        },
        //  拖拽
        draggableEnd() {
            if (!this.isDraggable) {
                this.$notify({
                    title: '温馨提示',
                    message: '题目顺序调整完成后记得点击底部的保存哦！ ^_^ ',
                    duration: 10000,
                    offset: 120
                });
            }
            this.isDraggable = true
        },
        //  拖拽结束
        onMove({relatedContext, draggedContext}) {
            const relatedElement = relatedContext.element;
            const draggedElement = draggedContext.element;
            return (
                (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
            );
        },
        //  获取会员等级列表
        async getLevel() {
            let _data = await getRankList()
            _data.data.map(item => {
                item.value = item.id
                item.label = item.name
            })
            this.infoForm.list = patternChange(this.infoForm.list,_data.data)
        },
        //  获取表单
        async getInformation() {
            let _data = await getPersonalInformation()
            // console.log(_data)
            if (_data.status === 200) this.infoForm.list = JSON.parse(_data.data.user_more_json)
            await this.getLevel()
        },
    },
    filters: {},
    watch: {
        isDragging(newValue) {
            if (newValue) {
                this.delayedDragging = true;
                return;
            }
            this.$nextTick(() => {
                this.delayedDragging = false;
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.wrapper {
    .add-btn {
        display: block;
        width: 200px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#0a2240, #0a2240);
        background-blend-mode: normal, normal;
        border-radius: 20px;
        border: none;
        padding: 0;
        font-size: 16px;
        color: #fff;
    }

    .classifys {
        margin-bottom: 20px;
        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            border-radius: 6px 0  0 6px;
            color: #ffb400;
            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 0 6px 6px 0;

            }
        }
    }

    .zt-img {
        margin-bottom: 22px;

        img {
            width: 40px;
        }
    }

    .set-box {
        margin-bottom: 22px;
        width: 210px;
    }
}
</style>
